<!-- ? V2 1XP -->
<template>
  <div>
    <div :class="$style.container">
      <div :class="$style.badgeContainer">
        <Badge
          v-for="badge in [
            ...(product.isNew ? ['Neu'] : []),
            ...(product.isBestSeller ? ['Bestseller'] : []),
          ]"
          :key="badge"
          color="blue"
          size="s"
          :text="badge"
        />
      </div>
      <div :class="$style.upperContainer">
        <div :class="$style.imageContainer">
          <img alt="" :class="$style.image" :src="product.image" />
        </div>

        <div :class="$style.content">
          <div :class="$style.typ">{{ productTypeRef }}</div>
          <a :class="$style.title" :href="product.primaryLink" v-html="product.title" />
          <div
            v-if="product.additionalText"
            :class="$style.subline"
            v-html="product.additionalText"
          />
        </div>
      </div>

      <div>
        <Divider :class="$style.divider" />
        <div :class="$style.properties">
          <div :class="$style.propertiesLeft">
            <Button
              v-if="product.datasheetLink"
              :class="$style.propertiesLeftButton"
              size="xs"
              start-icon="draft"
              target="blank"
              :text="storeTranslations.translations?.['shopProductTeaser.datasheet']"
              :url="product.datasheetLink"
              variant="linkStatic"
              @click="
                product.wtParams &&
                // @ts-ignore
                wtTrack(
                  { cat: 'PRODUCTRESULTSHANDLER' },
                  {
                    ...product.wtParams,
                    filename: product.datasheetLink,
                  },
                )
              "
            />
          </div>
          <div :class="$style.propertiesRight">
            <span v-if="product?.price" :class="$style.shopPrice">
              <div :class="$style.shopPriceText">
                {{ texts?.from }}
                <IndividualPrice
                  :btype-list="product?.btypeList"
                  :product-type="product?.type"
                  :quantity="Number(1)"
                  :value="Number(product.price)"
                />
              </div>

              <div :class="$style.shopPriceSubline">
                <span :class="$style.shopPriceTax">
                  {{ storeTranslations.translations?.['plusVat'] + ' & ' }}
                </span>
                <a v-if="shippingURLRef" :class="$style.shipping" :href="shippingURLRef">
                  {{ storeTranslations.translations?.['shipping'] }}
                </a>
              </div>
            </span>
          </div>
        </div>

        <div :class="$style.buttonsContainer">
          <Button
            v-if="product.secondaryButtonText"
            size="xs"
            :text="product.secondaryButtonText"
            :url="product.secondaryButtonUrl"
            variant="secondary"
          />
          <Button
            size="xs"
            :text="texts?.toProduct"
            :url="product?.primaryLink"
            variant="primary"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Badge from '../Badge/Badge.vue';
import Button from '../Button1XP/Button1XP.vue';
import Divider from '../Divider/Divider.vue';
import type { WindowWika } from '../../types/window';
import IndividualPrice from '../IndividualPrice/IndividualPrice.vue';
import { useStoreTranslations } from '../../store/translations/translations';

const props = defineProps({
  texts: {
    type: Object,
    default: () => {},
  },
  product: {
    type: Object,
    default: () => {},
  },
});

const _window = window as unknown as WindowWika;
const wtTrack = _window.wtTrack;

const storeTranslations = useStoreTranslations();

const shippingURLRef = computed(() => _window?.shippingURL);

const productTypeRef = computed(() => {
  const typeRaw = JSON.parse(props.product.type);

  if (!storeTranslations.translations) {
    return '';
  }

  if (typeRaw.length < 2) {
    return `${storeTranslations.translations?.['productType']} ${typeRaw}`;
  } else {
    return `${storeTranslations.translations?.['productTypes']} ${typeRaw.join(', ')}`;
  }
});
</script>

<style module lang="scss">
@forward './ShopProductTeaser.scss';
</style>
